// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxsol } from "../../../icons/full/build/icon-axsol.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxsolIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxsol.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxsolIcon.displayName = 'AxsolIcon';
}

export default AxsolIcon;